// Create types
export const CURRENCYTYPE_CREATE_ERROR = 'CURRENCYTYPE_CREATE_ERROR';
export const CURRENCYTYPE_CREATE_LOADING = 'CURRENCYTYPE_CREATE_LOADING';
export const CURRENCYTYPE_CREATE_SUCCESS = 'CURRENCYTYPE_CREATE_SUCCESS';
export const CURRENCYTYPE_CREATE_VIOLATIONS = 'CURRENCYTYPE_CREATE_VIOLATIONS';
export const CURRENCYTYPE_CREATE_RESET = 'CURRENCYTYPE_CREATE_RESET';

// Show types
export const CURRENCYTYPE_SHOW_ERROR = 'CURRENCYTYPE_SHOW_ERROR';
export const CURRENCYTYPE_SHOW_LOADING = 'CURRENCYTYPE_SHOW_LOADING';
export const CURRENCYTYPE_SHOW_RETRIEVED_SUCCESS = 'CURRENCYTYPE_SHOW_RETRIEVED_SUCCESS';
export const CURRENCYTYPE_SHOW_RESET = 'CURRENCYTYPE_SHOW_RESET';

// Update types
export const CURRENCYTYPE_UPDATE_RESET = 'CURRENCYTYPE_UPDATE_RESET';
export const CURRENCYTYPE_UPDATE_UPDATE_ERROR = 'CURRENCYTYPE_UPDATE_UPDATE_ERROR';
export const CURRENCYTYPE_UPDATE_UPDATE_LOADING = 'CURRENCYTYPE_UPDATE_UPDATE_LOADING';
export const CURRENCYTYPE_UPDATE_UPDATE_SUCCESS = 'CURRENCYTYPE_UPDATE_UPDATE_SUCCESS';
export const CURRENCYTYPE_UPDATE_RETRIEVE_ERROR = 'CURRENCYTYPE_UPDATE_RETRIEVE_ERROR';
export const CURRENCYTYPE_UPDATE_RETRIEVE_LOADING = 'CURRENCYTYPE_UPDATE_RETRIEVE_LOADING';
export const CURRENCYTYPE_UPDATE_RETRIEVE_SUCCESS = 'CURRENCYTYPE_UPDATE_RETRIEVE_SUCCESS';
export const CURRENCYTYPE_UPDATE_UPDATE_VIOLATIONS = 'CURRENCYTYPE_UPDATE_UPDATE_VIOLATIONS';

// List types
export const CURRENCYTYPE_LIST_ERROR = 'CURRENCYTYPE_LIST_ERROR';
export const CURRENCYTYPE_LIST_LOADING = 'CURRENCYTYPE_LIST_LOADING';
export const CURRENCYTYPE_LIST_RESET = 'CURRENCYTYPE_LIST_RESET';
export const CURRENCYTYPE_LIST_VIEW = 'CURRENCYTYPE_LIST_VIEW';
export const CURRENCYTYPE_LIST_SUCCESS = 'CURRENCYTYPE_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/currencytype/mutation-types.js